import { z } from "zod";
import {
  notificationTypeSchema,
  subscriptionParametersUnknownRecordSchema,
} from "../_shared";

export const updateSubscriptionsParametersPayloadSchema = z.object({
  type: notificationTypeSchema,
  parameters: subscriptionParametersUnknownRecordSchema,
});

export type UpdateSubscriptionsParametersPayload = z.infer<
  typeof updateSubscriptionsParametersPayloadSchema
>;
